// Un selector de dos o tres opciones con el mismo aspecto que "Mes / Lista" del calendario
// (`SelectorDeVista` en CalendarioDeRedes) — ADR-2026-10-29-dashboard-de-metricas-de-instagram.

export function SelectorSegmentado<T extends string | number>({
  opciones,
  valor,
  onCambiar,
  etiqueta,
}: {
  opciones: ReadonlyArray<{ valor: T; texto: string; icono?: JSX.Element }>;
  valor: T;
  onCambiar: (v: T) => void;
  /** Para lectores de pantalla: qué se elige. */
  etiqueta: string;
}) {
  return (
    <div role="group" aria-label={etiqueta} className="flex rounded-xl bg-neutral-100 p-1">
      {opciones.map((o) => (
        <button
          key={String(o.valor)}
          type="button"
          onClick={() => onCambiar(o.valor)}
          aria-pressed={valor === o.valor}
          className={`flex items-center gap-1.5 rounded-lg py-1.5 px-2.5 text-xs font-medium transition-colors ${
            valor === o.valor ? 'bg-white text-brand-black shadow-sm' : 'text-neutral-500 hover:text-brand-black'
          }`}
        >
          {o.icono}
          {o.texto}
        </button>
      ))}
    </div>
  );
}
